<div class="dx-card wide-card">
    <h4 class="content-block ap-green">O2 ASU Awards by Nominal Capacity</h4>

    <div class="content-block">
        <o2-report-filters (viewReport)="getO2PortalAwardsByNominalCapacity($event)"></o2-report-filters>
        <dx-responsive-box singleColumnScreen="xs sm md">
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".7"></dxi-col>
            <dxi-col [ratio]=".7"></dxi-col>
            <dxi-col [ratio]=".7"></dxi-col>
            <dxi-item>
                <dxi-location [row]="0" [col]="0" [colspan]="4"></dxi-location>
                <h4 class="cntent-block ap-green">Historical Awards: {{fromDate}} - {{toDate}}
                </h4>
                <div class="btndiv">
                    <dx-button icon="export" text="Export Charts" type="default" [width]="160"
                        (onClick)="exportCharts()">
                    </dx-button>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="1" [col]="0" [colspan]="4"></dxi-location>
                <h4 class="content-block" style="text-align: center;">Volume Analysis by Nominal ASU Capacity</h4>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="2" [col]="0" [colspan]="2"></dxi-location>
                <dx-pie-chart [resolveLabelOverlapping]="resolveOverlappingTypes[0]" id="dxPieChart" palette="soft"
                    [dataSource]="o2PortalAwardsByNominalCapacityPieChartData">
                    <dxi-series argumentField="asunominalCapacity" valueField="cumulativePercent">
                        <dxo-label [customizeText]="customizeLabel" [visible]="true">
                            <dxo-connector [visible]="true" [width]="1"></dxo-connector>
                        </dxo-label>
                    </dxi-series>
                    <dxo-size [width]="500"></dxo-size>
                </dx-pie-chart>
            </dxi-item>
            <dxi-item class="marginL30">
                <dxi-location [row]="2" [col]="2" [colspan]="2"></dxi-location>
                <div class="dx-field">
                    <dx-chart [customizePoint]="customizePoint" class="width100" #dxNominalCapacityBarChart
                        id="dxNominalCapacityBarChart" [dataSource]="o2PortalAwardsByNominalCapacityBarChartData">
                        <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                        <dxo-common-series-settings argumentField="awardYear" valueField="gaseousOxygen"
                            type="stackedBar">
                        </dxo-common-series-settings>
                        <dxi-value-axis position="left">
                            <dxo-title text="Total O2 (mtpd)"></dxo-title>
                        </dxi-value-axis>
                        <dxo-legend verticalAlignment="top" horizontalAlignment="center" [visible]="false">
                        </dxo-legend>
                        <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                            <dxo-format type="thousands" [precision]="1">
                            </dxo-format>
                        </dxo-tooltip>
                        <dxo-argument-axis [allowDecimals]="false">
                        </dxo-argument-axis>
                        <dxo-series-template nameField="asunominalCapacity"></dxo-series-template>
                        <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                    </dx-chart>
                </div>
            </dxi-item>
        </dx-responsive-box>
        <hr />
        <div class="btndiv">
            <dx-button icon="export" text="Export Grid" type="default" [width]="145" (onClick)="exportExcel($event)">
            </dx-button>
        </div>
        <div class="marginT15">
            <h4 class="lblmargin ap-green">Volume Analysis By Nominal ASU Capacity & Competitor</h4>
            <dx-pivot-grid class="grdmargin" #VolumeAnalysisByAsuNominalCapacityAndCompetitor
                id="VolumeAnalysisByAsuNominalCapacityAndCompetitor" [allowSortingBySummary]="true"
                [allowFiltering]="false" (onCellPrepared)="onCellPrepared($event)" [showBorders]="true"
                [showColumnGrandTotals]="true" [showRowGrandTotals]="true" [showRowTotals]="true"
                [showColumnTotals]="false" [dataSource]="pivotGridNominalASUCapacityAndCompititorDataSource">
                <dxo-field-chooser [enabled]="false" [height]="400"></dxo-field-chooser>
                <dxo-scrolling mode="virtual"></dxo-scrolling>
            </dx-pivot-grid>
        </div>
        <hr />
        <div class="marginT15">
            <h4 class="lblmargin ap-green">Analysis: Volume by Nominal ASU Capacity & Process</h4>
            <div class="dx-field">
                <dx-chart class="width100" palette="soft" #dxVolumeByNominalASUCapacityBarChart
                    id="dxVolumeByNominalASUCapacityBarChart"
                    [dataSource]="o2PortalAwardsVolumeByNominalASUCapacityBarChartData">
                    <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                    <dxo-common-series-settings argumentField="asunominalCapacity" valueField="totalOxygen"
                        type="stackedBar">
                    </dxo-common-series-settings>
                    <dxo-value-format formatter=""></dxo-value-format>
                    <dxi-value-axis position="left">
                        <dxo-title text="Total O2 (mtpd)"></dxo-title>
                    </dxi-value-axis>
                    <dxo-legend verticalAlignment="top" horizontalAlignment="center" [visible]="true">
                    </dxo-legend>
                    <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                        <dxo-format type="thousands" [precision]="0">
                        </dxo-format>
                    </dxo-tooltip>
                    <dxo-argument-axis [allowDecimals]="false">
                    </dxo-argument-axis>
                    <dxo-series-template nameField="process"></dxo-series-template>
                    <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                </dx-chart>
            </div>
        </div>
        <hr />
        <div class="marginT15">
            <h4 class="lblmargin ap-green">Analysis: Number of ASU by Nominal ASU Capacity & Process</h4>
            <div class="dx-field">
                <dx-chart palette="soft" class="width100" #dxNoOfASUByNominalASUCapacityBarChart
                    id="dxNoOfASUByNominalASUCapacityBarChart"
                    [dataSource]="o2PortalAwardsNoOfASUByNominalASUCapacityBarChartData">
                    <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                    <dxo-common-series-settings argumentField="asunominalCapacity" valueField="capacityAndProcessCount"
                        type="stackedBar">
                    </dxo-common-series-settings>
                    <dxi-value-axis position="left">
                        <dxo-title text="Number of ASUs"></dxo-title>
                    </dxi-value-axis>
                    <dxo-legend verticalAlignment="top" horizontalAlignment="center" [visible]="true">
                    </dxo-legend>
                    <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltipForNoOfASUs">
                    </dxo-tooltip>
                    <dxo-argument-axis [allowDecimals]="false">
                    </dxo-argument-axis>
                    <dxo-series-template nameField="process"></dxo-series-template>
                    <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                </dx-chart>
            </div>
        </div>
    </div>
</div>